export const FIELD_INFO = {
    name: {
        minLength: 1,
        maxLength: 200,
    },
    description: {
        minLength: 1,
        maxLength: 5000,
    },
    optionName: {
        maxLength: 255, // check real value
    },
    maxImages: 10,
    maxImagesLevel: 'product',
    isCategoryRequired: false,
} as const
